
<div class="unsub_page">
  <div class="unsub_box">

    @if (!showThankyou) {
      <div  class="cont_container">
        <div class="unsubc_confirm_text">{{middleContent?.text1}}</div>
        <div class="unsubs_button_parent">
          <button class="unsubc_button" [ngClass]="isUnsubscribed?'disable_unsub':''" [disabled]="isUnsubscribed" (click)="unsubscribeReminder()">{{middleContent?.title}}</button>
        </div>
      </div>
    }


    @if (showThankyou) {
      <div class="unsub_thankyou">{{middleContent?.text2}}</div>
    }
  </div>
</div>